var exports = {
  "kL": "x2b2fbebb--dea3e8--container",
  "Qs": "x2b2fbebb--dea3e8--content",
  "wx": "x2b2fbebb--dea3e8--header",
  "Qq": "x2b2fbebb--dea3e8--text",
};

module.exports = exports;
